(() => {
  const banner = document.querySelector('[data-cookie-consent]');
  if (!banner) return;
  const preferences = banner.querySelector('[data-cookie-preferences]');
  const customize = banner.querySelector('[data-cookie-action="customize"]');
  const status = banner.querySelector('[data-cookie-status]');
  const close = banner.querySelector('[data-cookie-close]');
  const inputs = [...banner.querySelectorAll('[data-cookie-category]')];
  const actions = [...banner.querySelectorAll('[data-cookie-action]')];
  let privacy;
  let returnFocus;
  let busy = false;
  let saveTimer;
  const passwordPage = document.body.classList.contains('template-password');
  const pendingStorageKey = 'kintsugi.pending.cookie-consent.v1';
  function pendingConsent() {
    try {
      const saved = JSON.parse(window.localStorage.getItem(pendingStorageKey));
      if (!saved || Date.now() - saved.savedAt > 180 * 24 * 60 * 60 * 1000) return null;
      if (!['preferences', 'analytics', 'marketing'].every((key) => typeof saved.consent?.[key] === 'boolean')) return null;
      return saved.consent;
    } catch (error) { return null; }
  }
  function rememberPasswordChoice(consent) {
    try {
      window.localStorage.setItem(pendingStorageKey, JSON.stringify({ consent, savedAt: Date.now() }));
      clearTimeout(saveTimer);
      busy = false;
      actions.forEach((button) => { button.disabled = false; });
      inputs.forEach((input) => { input.checked = consent[input.dataset.cookieCategory]; });
      hide();
    } catch (error) { fail('Your choices could not be saved. Please try again.'); }
  }

  // Local previews cannot reliably persist consent through Shopify's storefront API.
  // Keep preview choices separate from Shopify consent and never use this on a store.
  const localPreview = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(window.location.hostname);
  const previewStorageKey = 'kintsugi.preview.cookie-consent.v1';
  function previewPrivacy() {
    return {
      currentVisitorConsent() {
        try {
          const saved = JSON.parse(window.localStorage.getItem(previewStorageKey)) || {};
          return Object.fromEntries(['preferences', 'analytics', 'marketing'].map((key) => [
            key, saved[key] === 'yes' || saved[key] === 'no' ? saved[key] : ''
          ]));
        } catch (error) {
          return { preferences: '', analytics: '', marketing: '' };
        }
      },
      setTrackingConsent(consent, callback) {
        try {
          const saved = this.currentVisitorConsent();
          Object.keys(consent).forEach((key) => { saved[key] = consent[key] ? 'yes' : 'no'; });
          window.localStorage.setItem(previewStorageKey, JSON.stringify(saved));
        } catch (error) {
          callback({ error: true });
          return;
        }
        callback();
      }
    };
  }

  function syncInputs() {
    const consent = privacy.currentVisitorConsent();
    inputs.forEach((input) => { input.checked = consent[input.dataset.cookieCategory] === 'yes'; });
    return consent;
  }
  function show(expanded = false) {
    banner.hidden = false;
    preferences.hidden = !expanded;
    customize.setAttribute('aria-expanded', String(expanded));
  }
  function hide() {
    banner.hidden = true;
    status.textContent = '';
    if (returnFocus) returnFocus.focus();
    returnFocus = null;
  }
  function fail(message) {
    busy = false;
    clearTimeout(saveTimer);
    actions.forEach((button) => { button.disabled = false; });
    status.textContent = message;
  }
  function save(consent) {
    if (busy) return;
    if (!privacy) {
      if (passwordPage) rememberPasswordChoice(consent);
      return;
    }
    const saveFailed = () => {
      if (passwordPage) rememberPasswordChoice(consent);
      else fail('Your choices could not be saved. Please try again.');
    };
    busy = true;
    actions.forEach((button) => { button.disabled = true; });
    status.textContent = 'Saving your choices…';
    saveTimer = setTimeout(saveFailed, 10000);
    try {
      privacy.setTrackingConsent(consent, (result) => {
        if (!busy) return;
        if (result && result.error) {
          saveFailed();
          return;
        }
        const saved = privacy.currentVisitorConsent();
        if (!Object.keys(consent).every((key) => saved[key] === (consent[key] ? 'yes' : 'no'))) {
          saveFailed();
          return;
        }
        clearTimeout(saveTimer);
        busy = false;
        actions.forEach((button) => { button.disabled = false; });
        syncInputs();
        try { window.localStorage.removeItem(pendingStorageKey); } catch (error) {}
        hide();
      });
    } catch (error) { saveFailed(); }
  }
  actions.forEach((button) => button.addEventListener('click', () => {
    const action = button.dataset.cookieAction;
    if (action === 'customize') {
      const expanded = preferences.hidden;
      preferences.hidden = !expanded;
      customize.setAttribute('aria-expanded', String(expanded));
      return;
    }
    save(Object.fromEntries(inputs.map((input) => [
      input.dataset.cookieCategory,
      action === 'save' ? input.checked : action === 'accept'
    ])));
  }));
  close.addEventListener('click', () => { if (!busy) hide(); });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cookie-settings]');
    if (!trigger) return;
    returnFocus = trigger;
    if (privacy) syncInputs();
    else if (passwordPage) {
      const pending = pendingConsent();
      if (pending) inputs.forEach((input) => { input.checked = pending[input.dataset.cookieCategory]; });
    }
    show(true);
    close.hidden = false;
    banner.querySelector('[data-cookie-heading]').focus();
  });
  function ready(error) {
    privacy = localPreview ? previewPrivacy() : window.Shopify && window.Shopify.customerPrivacy;
    const pending = pendingConsent();
    if (error || !privacy) {
      privacy = null;
      if (passwordPage) {
        if (!pending) show();
        return;
      }
      show();
      actions.forEach((button) => { button.disabled = true; });
      status.textContent = 'Cookie settings are temporarily unavailable. Please reload to try again.';
      return;
    }
    const consent = syncInputs();
    if (pending && !localPreview) {
      inputs.forEach((input) => { input.checked = pending[input.dataset.cookieCategory]; });
      if (passwordPage) return;
      // Forward the choice already made by this visitor on the locked page.
      show();
      save(pending);
      return;
    }
    if (['analytics', 'marketing', 'preferences'].some((key) => !consent[key])) show();
  }
  if (localPreview) ready();
  else if (window.Shopify && window.Shopify.customerPrivacy) ready();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], ready);
    } catch (error) { ready(error); }
  } else ready(new Error('Customer Privacy API unavailable'));
})();
